import { ChatRoomStatus } from '@/types/schema.generated'
import * as v from 'valibot'

const segmentLineActivationLoginLinkSchema = v.object({
  not: v.boolean(),
})

const segmentInflowSourceSchema = v.object({
  inflowSourceDefinitionGUID: v.pipe(
    v.string(),
    v.nonEmpty('友だち追加経路が選択されていません')
  ),
  not: v.boolean(),
})

const segmentClickURLSchema = v.object({
  url: v.pipe(v.string(), v.nonEmpty('URLが入力されていません')),
  not: v.boolean(),
})

const segmentPlannerEnqueteAnsweredSchema = v.object({
  enqueteGUID: v.pipe(v.string(), v.nonEmpty('アンケートが選択されていません')),
  not: v.boolean(),
})

const structRoomStatus = {
  ActionRequired: ChatRoomStatus.ActionRequired,
  Appointed: ChatRoomStatus.Appointed,
  Archived: ChatRoomStatus.Archived,
  ContractConcluded: ChatRoomStatus.ContractConcluded,
  ContractConcludedInsurance: ChatRoomStatus.ContractConcludedInsurance,
  ContractConcludedSecuritie: ChatRoomStatus.ContractConcludedSecurities,
  GotComplaints: ChatRoomStatus.GotComplaints,
  Keeping: ChatRoomStatus.Keeping,
  LostOrder: ChatRoomStatus.LostOrder,
  Messaging: ChatRoomStatus.Messaging,
  NotDefined: ChatRoomStatus.NotDefined,
  Offering: ChatRoomStatus.Offering,
  WaitingForFirstAppointment: ChatRoomStatus.WaitingForFirstAppointment,
}

const enumChatRoomStatus = v.enum(structRoomStatus)

const segmentRoomStatusSchema = v.pipe(
  v.object({
    status: v.union([enumChatRoomStatus, v.string()]),
    not: v.boolean(),
  }),
  v.forward(
    v.check(({ status }) => {
      if (status === undefined) {
        return false
      }
      if (Object.values(structRoomStatus).some(s => (s as string) === status)) {
        return true
      }
      return false
    }, '対応状況が選択されていません'),
    ['status']
  ),
  v.object({
    status: enumChatRoomStatus,
    not: v.boolean(),
  })
)

const segmentUserVariableDefinitionSchema = v.pipe(
  v.object({
    definitionGUID: v.pipe(
      v.string(),
      v.nonEmpty('カスタム項目が選択されていません')
    ),
    values: v.array(v.string()),
    not: v.boolean(),
  }),
  v.forward(
    v.check(({ values }) => {
      if (values.length === 0 || values.includes('')) {
        return false
      }
      return true
    }, 'カスタム項目の選択肢が選択されていません'),
    ['values']
  )
)

const conditionSchema = v.object({
  loginLinkCondition: v.optional(segmentLineActivationLoginLinkSchema),
  inflowSourceCondition: v.optional(segmentInflowSourceSchema),
  clickURLCondition: v.optional(segmentClickURLSchema),
  enqueteAnsweredCondition: v.optional(segmentPlannerEnqueteAnsweredSchema),
  roomStatusCondition: v.optional(segmentRoomStatusSchema),
  userVariableDefinitionCondition: v.optional(
    segmentUserVariableDefinitionSchema
  ),
})

export const segmentSchema = v.object({
  conditions: v.array(conditionSchema),
})
